import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Heart, Users, Globe, Shield, Award, Target } from 'lucide-react';

const AboutPage = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero */}
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4">{t('aboutFundTheHopeTitle')}</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              {t('ourMission')}
            </p>
          </div>

          {/* Story */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t('ourStoryTitle')}</h2>
            <div className="prose prose-lg text-muted-foreground">
              <p className="mb-4">
                {t('ourStoryText')}
              </p>
            </div>
          </section>

          {/* Values */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-6">{t('ourValuesTitle')}</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-card border border-border rounded-xl p-6">
                <Shield className="w-8 h-8 text-emerald-500 mb-3" />
                <h3 className="font-semibold text-foreground mb-2">{t('trustAndSafetyValue')}</h3>
                <p className="text-muted-foreground">{t('trustAndSafetyDesc')}</p>
              </div>
              <div className="bg-card border border-border rounded-xl p-6">
                <Globe className="w-8 h-8 text-teal-500 mb-3" />
                <h3 className="font-semibold text-foreground mb-2">{t('globalReachValue')}</h3>
                <p className="text-muted-foreground">{t('globalReachDesc')}</p>
              </div>
              <div className="bg-card border border-border rounded-xl p-6">
                <Users className="w-8 h-8 text-emerald-500 mb-3" />
                <h3 className="font-semibold text-foreground mb-2">{t('communityFirstValue')}</h3>
                <p className="text-muted-foreground">{t('communityFirstDesc')}</p>
              </div>
              <div className="bg-card border border-border rounded-xl p-6">
                <Target className="w-8 h-8 text-teal-500 mb-3" />
                <h3 className="font-semibold text-foreground mb-2">{t('transparencyValue')}</h3>
                <p className="text-muted-foreground">{t('transparencyDesc')}</p>
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="bg-gradient-to-r from-emerald-500/10 to-teal-500/10 rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold text-foreground mb-6">{t('ourImpactTitle')}</h2>
            <div className="grid grid-cols-3 gap-6">
              <div>
                <div className="text-3xl font-bold text-emerald-500">Global</div>
                <div className="text-muted-foreground">Impact</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-teal-500">Growing</div>
                <div className="text-muted-foreground">{t('campaignsLabel')}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-emerald-500">Worldwide</div>
                <div className="text-muted-foreground">Community</div>
              </div>
            </div>
          </section>
          
          {/* Press & Media */}
          <section className="mt-8 text-center">
            <p className="text-muted-foreground">
              For press inquiries, contact{' '}
              <a href="mailto:press@fundthehope.com" className="text-emerald-500 hover:underline">press@fundthehope.com</a>
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
